const appConfig = {
    // apiPrefix: 'http://mongo.badak.in/api/',
    apiPrefix: 'http://speed-test.badak.in/api/',
    // apiPrefix: 'http://localhost:5002/api/',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
}

export default appConfig
